export const EDIT_ALERT = 'edit';
export const DELETE_ALERT = 'delete';

export const TOAST_TIMEOUT = 8000;

export default {
  TOAST_TIMEOUT,
  EDIT_ALERT,
  DELETE_ALERT
};
